import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { BottomNav } from './BottomNav';

/**
 * Live-app shell: fixed phone column (480px), panel fundal under the whole app,
 * bottom nav aligned to the same column width. Not a wide desktop stretch.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isFeed = location.pathname === '/feed' || location.pathname === '/';

  return (
    <div
      className={
        isFeed
          ? 'elix-app-shell elix-feed-chrome-shell fixed inset-0 flex h-[100dvh] w-full flex-col overflow-hidden font-sans text-white'
          : 'elix-app-shell fixed inset-0 flex h-[100dvh] w-full flex-col overflow-hidden font-sans text-white'
      }
    >
      <main className="feed-column-width relative min-h-0 w-full flex-1 self-center overflow-hidden">
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>{children}</Suspense>
        </ErrorBoundary>
      </main>
      <BottomNav />
    </div>
  );
}

function PageLoader() {
  return (
    <div className="flex h-full min-h-0 flex-col items-center justify-center p-4 text-white">
      <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-white/20 border-t-white" />
      <p className="text-white/70">Loading…</p>
    </div>
  );
}
